import { Link } from "@tanstack/react-router";
import { ArrowRight } from "lucide-react";
import { keywordHubs } from "@/lib/keyword-hubs";

export function KeywordHubLinks({
  heading = "Explore more about Raj Shamani",
  className = "",
  exclude = [],
}: {
  heading?: string;
  className?: string;
  /** Route paths to hide (e.g. the page you're already on) */
  exclude?: string[];
}) {
  const hubs = keywordHubs.filter((h) => !exclude.includes(h.to));

  return (
    <section className={`mx-auto max-w-5xl px-6 py-16 ${className}`}>
      <h2 className="text-2xl md:text-3xl font-bold mb-8">{heading}</h2>
      <div className="grid md:grid-cols-3 gap-4">
        {hubs.map((h) => (
          <Link
            key={h.to}
            to={h.to}
            className="group block p-6 rounded-xl bg-card border border-border hover:border-gold/50 transition"
          >
            <h.icon size={18} className="text-gold mb-3" />
            <div className="font-bold mb-2 inline-flex items-center gap-2">
              {h.title}
              <ArrowRight
                size={14}
                className="text-gold group-hover:translate-x-1 transition"
              />
            </div>
            <p className="text-sm text-muted-foreground leading-relaxed">{h.desc}</p>
          </Link>
        ))}
      </div>
    </section>
  );
}
